import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';
// import { Client } from '@/app/api/clients/clients.types';

interface LinkCellCellProps {
	// url: Client['clientUrl'];
	url: string;
	label: string;
}

const LinkCell: React.FC<LinkCellCellProps> = ({ url, label }): React.ReactNode => (
	<Typography
		component={Link}
		to={url}
		variant="body1"
		color="primary"
		onClick={(event: React.MouseEvent<HTMLAnchorElement>) => event.stopPropagation()}
		target="_blank"
	>
		{label}
	</Typography>
);

export default LinkCell;
